import { forwardRef, useId, type TextareaHTMLAttributes } from 'react';

import { cn } from '@/utils';

import { Field, fieldStyles, getFieldIds } from '../Field';

export interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'id'> {
  label: string;
  hint?: string;
  error?: string;
  id?: string;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { label, hint, error, id, className, required, rows = 5, ...props },
  ref,
) {
  const generatedId = useId();
  const textareaId = id ?? generatedId;
  const { describedBy } = getFieldIds(textareaId, hint, error);

  return (
    <Field id={textareaId} label={label} hint={hint} error={error} required={required}>
      <textarea
        ref={ref}
        id={textareaId}
        rows={rows}
        className={cn(
          fieldStyles.control,
          fieldStyles.textarea,
          error && fieldStyles.controlInvalid,
          className,
        )}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        required={required}
        {...props}
      />
    </Field>
  );
});
